import * as React from 'react';
import { SVGProps } from 'react';

const IconPlaySizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.3 15.201a1.382 1.382 0 0 0 0-2.402L8.209 3.349C7.239 2.78 6 3.455 6 4.551v18.898c0 1.096 1.24 1.77 2.208 1.202L24.3 15.2Z"
    />
  </svg>
);
export default IconPlaySizeL;
